import React from 'react'
import Section from '../Section'
import Markdown from 'features/Markdown'

export default props => (
  <Section
    color={props.color}
    fullHeight={props.fullHeight}
    paddingTop={props.paddingTop}
    paddingBottom={props.paddingBottom}
    sectionWidth={props.sectionWidth}
    style={props.centerText ? { textAlign: 'center' } : {}}
    pattern={props.pattern}
  >
    <Markdown text={props.text} color={props.color} />
  </Section>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/Col1Text/Col1Text.jsx